import React, { useState } from 'react';
import { UNITS } from '../constants/inventory';

const CUSTOM = '__custom__';

interface Props {
  value: string;
  onChange: (unit: string) => void;
  required?: boolean;
}

// A plain dropdown can't cover every unit a household actually uses (a can
// with a specific size, a regional term, whatever a receipt scan happened
// to read off). "Custom..." drops into a free-text field instead of forcing
// a mismatch -- also used to gracefully show a scanned unit that isn't in
// the standard list at all, rather than silently failing to select anything.
const UnitSelect: React.FC<Props> = ({ value, onChange, required }) => {
  const [customMode, setCustomMode] = useState(value !== '' && !UNITS.includes(value));

  const selectValue = customMode ? CUSTOM : value;

  return (
    <div className="unit-select-group">
      <select
        value={selectValue}
        onChange={(e) => {
          const next = e.target.value;
          if (next === CUSTOM) {
            setCustomMode(true);
            onChange('');
          } else {
            setCustomMode(false);
            onChange(next);
          }
        }}
        required={required && !customMode}
      >
        <option value="">Select...</option>
        {UNITS.map((u) => (
          <option key={u} value={u}>{u}</option>
        ))}
        <option value={CUSTOM}>Custom...</option>
      </select>
      {customMode && (
        <input
          type="text"
          className="unit-custom-input"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onFocus={(e) => e.target.select()}
          placeholder="e.g. 14.5oz can"
          required={required}
        />
      )}
    </div>
  );
};

export default UnitSelect;
